function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd" transform="translate(0 -.003)"><circle fill="#4a90e2" cx="37.891" cy="37.845" r="37.5" /><path d="M60.12 35.37c0 9.478-9.455 17.16-21.12 17.16-1.121 0-2.22-.071-3.293-.209-4.537 4.537-9.951 5.35-15.187 5.47v-1.11c2.827-1.385 5.28-3.909 5.28-6.791a7.97 7.97 0 0 0-.09-1.184c-4.777-3.146-7.83-7.952-7.83-13.336 0-9.478 9.455-17.16 21.12-17.16 11.665 0 21.12 7.682 21.12 17.16m-24.62.135h8v8h-8v-8m-5.192 0l9.192-9.192 9.192 9.192H30.307" fill="#fff" /></g></svg>;
});